// LocalStorage-backed preset store for visual settings.
const KEY = "keyvision.presets.v1";

export function loadPresets() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

export function savePresets(presets) {
  localStorage.setItem(KEY, JSON.stringify(presets));
}

export function addPreset(preset) {
  const list = loadPresets();
  // If a preset with the same name exists, replace it
  const idx = list.findIndex((p) => p.name === preset.name);
  if (idx >= 0) list[idx] = preset;
  else list.push(preset);
  savePresets(list);
  return list;
}

export function deletePreset(name) {
  const list = loadPresets().filter((p) => p.name !== name);
  savePresets(list);
  return list;
}
